














// @ts-nocheck
let map: any;
const zoom = 14;
const handler: any = [];
let img: any;
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class MapMarkers extends Vue {
  private arr: any = [];
  visible: any = false;
  mapPointArr: any = [];
  img_nj: any;
  img_jzs: any;
  index: any = 0;

  private created() {}

  private mounted() {}

  markPoint() {
    if (this.mapPointArr > 0) {
      return false;
    }
    if (handler[this.index]) handler[this.index].close();
    handler[this.index] = new T.MarkTool(map, { follow: true });
    handler[this.index].open();
    handler[this.index].addEventListener('mouseup', (e: any) => {
      console.log(e);
      this.mapPointArr.push(e.currentLnglat);
      // this.index += 1;
    });
  }

  clearPoint() {
    this.mapPointArr = [];
    map.clearOverLays();
    this.setMapImg();
  }

  private hideDialog() {
    this.close();
  }

  showDialog(pointArr: any) {
    // pointArr: [{lng:104.55,lat:22.9}]
    this.mapPointArr = pointArr || [];
    this.visible = true;
    this.$nextTick(() => {
      this.showMap();
    });
    if (this.mapPointArr[0].lat === null) {
      this.mapPointArr.length = 0;
    }
  }

  showMap() {
    const imageURL = 'http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=4c3a4b8cec3d4af47a12cdd192ce35cb';
    //创建自定义图层对象
    const lay = new T.TileLayer(imageURL, { minZoom: 13, maxZoom: 18 });
    map = new T.Map('MarkMapDiv', { layers: [lay] });
    console.log(map);
    map.centerAndZoom(new T.LngLat(104.55, 22.9), zoom);

    const typeArr: any = [
      {
        // title: '卫星',
        title: '',
        icon: ' http://api.tianditu.gov.cn/v4.0/image/map/maptype/satellite.png',
        layer: TMAP_SATELLITE_MAP,
      },
      {
        // title: '地图', //地图控件上所要显示的图层名称
        title: '', //地图控件上所要显示的图层名称
        icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/vector.png', //地图控件上所要显示的图层图标（默认图标大小80x80）
        layer: TMAP_NORMAL_MAP, //地图类型对象，即MapType。
      },
    ];
    const ctrl = new T.Control.MapType(typeArr);
    //添加控件
    map.addControl(ctrl);

    map.addEventListener('maptypechange', (e: any) => {
      console.log(e);
      //e.mapType 就是 当前切换的MapType 配置的地图
      if (e.mapType.name == 'TMAP_NORMAL_MAP') {
        // 普通地图 覆盖图隐藏
        this.img_nj.hide();
        this.img_jzs.hide();
      } else {
        this.img_nj.show();
        this.img_jzs.show();
      }
    });

    map.setMinZoom(13);
    map.setMaxZoom(18);

    map.setMaxBounds(new T.LngLatBounds(new T.LngLat(104.45, 22.84), new T.LngLat(104.65, 22.96)));

    this.setMapImg();

    this.mapPointArr &&
      this.mapPointArr.forEach((item: any) => {
        const marker = new T.Marker(new T.LngLat(item.lng, item.lat));
        //向地图上添加标注
        map.addOverLay(marker);
      });

    const config = {
      showLabel: true,
      color: '#f14343',
      weight: 2,
      opacity: 1,
      fillColor: '#f14343',
      fillOpacity: 0.2,
    };
    //创建标注工具对象
    const polygonTool = new T.PolygonTool(map, config);
  }

  setMapImg() {
    const bd = new T.LngLatBounds(new T.LngLat(104.5548, 22.8871), new T.LngLat(104.5648, 22.8924));
    this.img_jzs = new T.ImageOverlay('map/img/map-s-jzs.png', bd, {
      opacity: 1,
      alt: '', // 名称
    });
    map.addOverLay(this.img_jzs);

    const bd_nj = new T.LngLatBounds(new T.LngLat(104.5573, 22.8752), new T.LngLat(104.5773, 22.8856));
    this.img_nj = new T.ImageOverlay('map/img/map-s-nj.png', bd_nj, {
      opacity: 1,
      alt: '', // 名称
    });
    map.addOverLay(this.img_nj);
  }

  private close() {
    this.visible = false;
  }

  private save() {
    const data: any = this.mapPointArr;
    this.$emit('backData', data);
    this.hideDialog();
  }
}
